// The one scorecards door another feature reaches: staging a KPI target file for the Orpheus setup
// chat (ORP-26203). Orpheus never imports this island's api class — it gets the file's ref and row
// count back, and the turn that reads the file is Orpheus's own.
import { ScorecardApi } from '../api/ScorecardApi'

export interface StagedScorecardFile {
  fileRef: string
  rowCount: number | null
}

/** The two kinds the stage door reads (`scorecards/services/ingest/parse.py::ACCEPTED_FILE_TYPES`). */
export const STAGEABLE_FILE_ACCEPT =
  '.csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export function isStageableFile(file: File): boolean {
  const name = file.name.toLowerCase()
  return (
    name.endsWith('.csv') ||
    name.endsWith('.xlsx') ||
    file.type === 'text/csv' ||
    file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  )
}

export async function stageScorecardFile(
  accountId: number,
  workspaceId: number,
  file: File,
  signal?: AbortSignal,
  api: ScorecardApi = new ScorecardApi(),
): Promise<StagedScorecardFile> {
  const payload = await api.csvStage(accountId, workspaceId, file, signal)
  return {
    fileRef: typeof payload.file_ref === 'string' ? payload.file_ref : '',
    rowCount: typeof payload.row_count === 'number' ? payload.row_count : null,
  }
}
